// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"203428e3","328":"b6e0d203","331":"513591ea","416":"3dedf321","561":"83b4d5da","614":"b6312e18","676":"7e4c4762","740":"9a37bee0","886":"0b2de06f"}[chunkId] + ".chunk.js";
};